import {
  createAsyncThunk,
  createEntityAdapter,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import axios from "axios";
import BASEUtils from "../../../../@BASE/utils";
import { addUser, removeUser, updateUser } from "./userSlice";

export const getUsers = createAsyncThunk(
  "users/getUsers",
  async (params, { getState }) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_SERVICE_URL}/api/users`
    );

    const data = await response.data;

    return { data };
  }
);

const usersAdapter = createEntityAdapter({});

export const selectSearchText = ({ users }) => users.list.searchText;

export const { selectAll: selectUsers, selectById: selectUsersById } =
  usersAdapter.getSelectors((state) => state.users.list);

export const selectFilteredUsers = createSelector(
  [selectUsers, selectSearchText],
  (users, searchText) => {
    if (searchText.length === 0) {
      return users;
    }
    return BASEUtils.filterArrayByString(users, searchText);
  }
);

export const selectGroupedFilteredUsers = createSelector(
  [selectFilteredUsers],
  (users) => {
    return users
      .sort((a, b) =>
        a.first_name.localeCompare(b.first_name, "es", { sensitivity: "base" })
      )
      .reduce((r, e) => {
        // get first letter of title of current element
        const group = e.first_name[0];
        // if there is no property in accumulator with this letter create it
        if (!r[group]) r[group] = { group, children: [e] };
        // if there is push current element to children array for that letter
        else r[group].children.push(e);
        // return accumulator
        return r;
      }, {});
  }
);

const usersSlice = createSlice({
  name: "users",
  initialState: usersAdapter.getInitialState({
    searchText: "",
  }),
  reducers: {
    setUsersSearchText: {
      reducer: (state, action) => {
        state.searchText = action.payload;
      },
      prepare: (event) => ({ payload: event.target.value || "" }),
    },
  },
  extraReducers: {
    [updateUser.fulfilled]: usersAdapter.upsertOne,
    [addUser.fulfilled]: usersAdapter.addOne,
    [removeUser.fulfilled]: (state, action) =>
      usersAdapter.removeOne(state, action.payload),
    [getUsers.fulfilled]: (state, action) => {
      const { data, routeParams } = action.payload;
      usersAdapter.setAll(state, data);
      state.searchText = "";
    },
  },
});

export const { setUsersSearchText } = usersSlice.actions;

export const selectUserEntities = ({ users }) => users.list.entities;

export default usersSlice.reducer;
